export default __webpack_public_path__ + "6e9307e8ecadeaaab0a65dd0dfe6453b.jpg";